import { ILessonCardActivity } from 'interfaces'

interface ActivityTextProps {
  activity: string | ILessonCardActivity | { id: string; name: string }
}

export const Activity = ({ activity }: ActivityTextProps) => {
  const activityText = typeof activity === 'string'
    ? activity
    : 'title' in activity
      ? activity.title
      : 'name' in activity
        ? activity.name
        : ''

  return (
    <>
      {activityText}
    </>
  )
}
